import {
  getVideosModels,
  getVideosCategories,
  getAdminVideoCategories,
  getAdminVideoTypes,
  getVideosList,
  getVideosUpload,
  postVideo,
  putVideo,
  deleteVideo,
  getVideosLanguages,
} from '../utils/requests/videosAPI'

export const LOAD_VIDEOS = 'LOAD_VIDEOS'
export const LOAD_VIDEOS_PENDING = 'LOAD_VIDEOS_PENDING'
export const LOAD_VIDEOS_FULFILLED = 'LOAD_VIDEOS_FULFILLED'
export const LOAD_VIDEOS_REJECTED = 'LOAD_VIDEOS_REJECTED'

export const LOAD_NEW_VIDEOS = 'LOAD_NEW_VIDEOS'
export const LOAD_NEW_VIDEOS_PENDING = 'LOAD_NEW_VIDEOS_PENDING'
export const LOAD_NEW_VIDEOS_FULFILLED = 'LOAD_NEW_VIDEOS_FULFILLED'
export const LOAD_NEW_VIDEOS_REJECTED = 'LOAD_NEW_VIDEOS_REJECTED'

export const LOAD_VIDEOS_UPLOAD = 'LOAD_VIDEOS_UPLOAD'
export const LOAD_VIDEOS_UPLOAD_PENDING = 'LOAD_VIDEOS_UPLOAD_PENDING'
export const LOAD_VIDEOS_UPLOAD_FULFILLED = 'LOAD_VIDEOS_UPLOAD_FULFILLED'
export const LOAD_VIDEOS_UPLOAD_REJECTED = 'LOAD_VIDEOS_UPLOAD_REJECTED'

export const LOAD_NEW_VIDEOS_UPLOAD = 'LOAD_NEW_VIDEOS_UPLOAD'
export const LOAD_NEW_VIDEOS_UPLOAD_PENDING = 'LOAD_NEW_VIDEOS_UPLOAD_PENDING'
export const LOAD_NEW_VIDEOS_UPLOAD_FULFILLED = 'LOAD_NEW_VIDEOS_UPLOAD_FULFILLED'
export const LOAD_NEW_VIDEOS_UPLOAD_REJECTED = 'LOAD_NEW_VIDEOS_UPLOAD_REJECTED'

export const LOAD_VIDEO_MODELS = 'LOAD_VIDEO_MODELS'
export const LOAD_VIDEO_MODELS_PENDING = 'LOAD_VIDEO_MODELS_PENDING'
export const LOAD_VIDEO_MODELS_FULFILLED = 'LOAD_VIDEO_MODELS_FULFILLED'
export const LOAD_VIDEO_MODELS_REJECTED = 'LOAD_VIDEO_MODELS_REJECTED'

export const LOAD_VIDEO_CATEGORIES = 'LOAD_VIDEO_CATEGORIES'
export const LOAD_VIDEO_CATEGORIES_PENDING = 'LOAD_VIDEO_CATEGORIES_PENDING'
export const LOAD_VIDEO_CATEGORIES_FULFILLED = 'LOAD_VIDEO_CATEGORIES_FULFILLED'
export const LOAD_VIDEO_CATEGORIES_REJECTED = 'LOAD_VIDEO_CATEGORIES_REJECTED'

export const LOAD_VIDEO_LANGUAGES = 'LOAD_VIDEO_LANGUAGES'
export const LOAD_VIDEO_LANGUAGES_PENDING = 'LOAD_VIDEO_LANGUAGES_PENDING'
export const LOAD_VIDEO_LANGUAGES_FULFILLED = 'LOAD_VIDEO_LANGUAGES_FULFILLED'
export const LOAD_VIDEO_LANGUAGES_REJECTED = 'LOAD_VIDEO_LANGUAGES_REJECTED'

export const LOAD_ADMIN_VIDEO_CATEGORIES = 'LOAD_ADMIN_VIDEO_CATEGORIES'
export const LOAD_ADMIN_VIDEO_CATEGORIES_PENDING = 'LOAD_ADMIN_VIDEO_CATEGORIES_PENDING'
export const LOAD_ADMIN_VIDEO_CATEGORIES_FULFILLED = 'LOAD_ADMIN_VIDEO_CATEGORIES_FULFILLED'
export const LOAD_ADMIN_VIDEO_CATEGORIES_REJECTED = 'LOAD_ADMIN_VIDEO_CATEGORIES_REJECTED'

export const LOAD_ADMIN_VIDEO_TYPES = 'LOAD_ADMIN_VIDEO_TYPES'
export const LOAD_ADMIN_VIDEO_TYPES_PENDING = 'LOAD_ADMIN_VIDEO_TYPES_PENDING'
export const LOAD_ADMIN_VIDEO_TYPES_FULFILLED = 'LOAD_ADMIN_VIDEO_TYPES_FULFILLED'
export const LOAD_ADMIN_VIDEO_TYPES_REJECTED = 'LOAD_ADMIN_VIDEO_TYPES_REJECTED'

export const POST_VIDEO = 'POST_VIDEO'
export const POST_VIDEO_PENDING = 'POST_VIDEO_PENDING'
export const POST_VIDEO_FULFILLED = 'POST_VIDEO_FULFILLED'
export const POST_VIDEO_REJECTED = 'POST_VIDEO_REJECTED'

export const PUT_VIDEO = 'PUT_VIDEO'
export const PUT_VIDEO_PENDING = 'PUT_VIDEO_PENDING'
export const PUT_VIDEO_FULFILLED = 'PUT_VIDEO_FULFILLED'
export const PUT_VIDEO_REJECTED = 'PUT_VIDEO_REJECTED'

export const DELETE_VIDEO = 'DELETE_VIDEO'
export const DELETE_VIDEO_PENDING = 'DELETE_VIDEO_PENDING'
export const DELETE_VIDEO_FULFILLED = 'DELETE_VIDEO_FULFILLED'
export const DELETE_VIDEO_REJECTED = 'DELETE_VIDEO_REJECTED'

export const CLEAR_VIDEOS_MESSAGES = 'CLEAR_VIDEOS_MESSAGES'

export function loadVideos(queryParams, refetch = false, limit) {
  return {
    type: refetch ? LOAD_NEW_VIDEOS : LOAD_VIDEOS,
    payload: getVideosList(queryParams, limit),
  }
}

export function loadVideosUpload(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_VIDEOS_UPLOAD : LOAD_VIDEOS_UPLOAD,
    payload: getVideosUpload(queryParams),
  }
}

export function loadVideoModels() {
  return {
    type: LOAD_VIDEO_MODELS,
    payload: getVideosModels(),
  }
}

export function loadVideoCategories() {
  return {
    type: LOAD_VIDEO_CATEGORIES,
    payload: getVideosCategories(),
  }
}

export function loadVideoLanguages() {
  return {
    type: LOAD_VIDEO_LANGUAGES,
    payload: getVideosLanguages(),
  }
}

export function loadAdminVideoCategories() {
  return {
    type: LOAD_ADMIN_VIDEO_CATEGORIES,
    payload: getAdminVideoCategories(),
  }
}

export function loadAdminVideoTypes() {
  return {
    type: LOAD_ADMIN_VIDEO_TYPES,
    payload: getAdminVideoTypes(),
  }
}

export function createVideo(bodyParams) {
  return {
    type: POST_VIDEO,
    payload: postVideo(bodyParams),
  }
}

export function updateVideo(id, bodyParams) {
  return {
    type: PUT_VIDEO,
    payload: putVideo(id, bodyParams),
  }
}

export function removeVideo(id) {
  return {
    type: DELETE_VIDEO,
    payload: deleteVideo(id),
    meta: { id },
  }
}

export function clearVideosMessages() {
  return {
    type: CLEAR_VIDEOS_MESSAGES,
  }
}
